import { ApiService } from '../apiService.service';
import { Injectable } from '@angular/core';
import { Learning_Type } from '@app/enums/learning-type.enum';
import { SearchObject } from '@app/models/_index';
import { SearchObjectAdapter } from '@app/adapters/_index';
import { SearchObjectInterface } from '@app/interfaces/_index';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private searchCoursesURL = `${environment.beyondApi.url}/v2/getcourses`;

  constructor(private apiService: ApiService, private adapter: SearchObjectAdapter) {}

  /**
   * TODO: Refactor to be an observable
   * Get search objects
   * @param - getObjects
   * @return - object promise
   */
  _getObjects(params, includeFiltered): Promise<SearchObject[]> {
    return this.apiService
      .post(this.searchCoursesURL, JSON.stringify(params))
      .then((response: any) => {
        const searchObjects: SearchObject[] = [];
        if (response && response.body && response.body.data) {
          // Filter out objects with Pointillist in the name
          const filteredData = response.body.data.filter(
            (catalog: SearchObjectInterface) =>
              includeFiltered || !catalog.data.name.includes('Pointillist')
          );
          filteredData.forEach((catalog: SearchObjectInterface) => {
            // NOTE: Search Object contains both course and subscription items
            searchObjects.push(this.adapter.adapt(catalog));
          });
        }
        return Promise.resolve(searchObjects);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  /**
   * TODO: Refactor
   * Return all search objects
   * @param options - search options any
   * @returns - returns all search objects promise
   */
  _getAllObjects(options: any): Promise<any> {
    const courseParams = {
      query: options.query,
      role: options.roleFilterArray,
      category_id: options.productFilterArray,
      topic: options.topicFilterArray,
      learningType: options.learningTypeArray,
      course: options.courseAvailabilityFilterArray,
      api_key: `${environment.search_api}`,
    };

    return this._getObjects(courseParams, options.includeFiltered || false)
      .then((results) => {
        return results;
      })
      .catch((error) => {
        return Promise.reject('Get all Search Objects error' + error);
      });
  }

  /**
   * TODO: Refactor
   * Return search courses
   * @param options - search options any
   * @returns - returns search objects promise
   */
  getSearchCourses(options: any): Promise<any> {
    return this._getAllObjects(options)
      .then((results) => {
        // NOTE: Learning Plan is the same thing as Subscription
        const subscriptions = results.filter((obj) => obj.type === Learning_Type.SUBSCRIPTION);
        const courses = results.filter((obj) => obj.type !== Learning_Type.SUBSCRIPTION);
        const all = [].concat(subscriptions, courses);
        return all;
      })
      .catch((error) => {
        return Promise.reject('Get search courses service error' + error);
      });
  }
}
